import i18n from '@/main';

const dataAtual = new Date();
const mesAtual = dataAtual.getMonth() + 1;
const anoAtual = dataAtual.getFullYear();
const mesAnoFormatado = `${mesAtual.toString().padStart(2, '0')}/${anoAtual}`;

export default {
    methods: {
        mxItemsMenuPF(dados) {
            let itemsMenu = [
                {
                    index: '0',
                    icon: 'mdi mdi-cash',
                    name: i18n.t('mensagens.preAnaliseCredito.modulos.dadosFinanceiros'),
                    searchSucceeded: true
                },
                {
                    index: '1',
                    icon: 'mdi mdi-gavel',
                    name: i18n.t('mensagens.preAnaliseCredito.modulos.dadosFiscaisTributarios'),
                    searchSucceeded: true,
                    disabled: false
                },
                {
                    index: '2',
                    icon: 'mdi mdi-handshake-outline',
                    name: i18n.t('mensagens.preAnaliseCredito.modulos.informacoesProfissionais'),
                    searchSucceeded: true,
                    disabled: false
                },
                {
                    index: '3',
                    icon: 'mdi mdi-cloud-search-outline',
                    name: i18n.t('mensagens.preAnaliseCredito.modulos.informacoesPublicasBndes'),
                    searchSucceeded: true,
                    disabled: false
                },
                {
                    index: '4',
                    icon: 'mdi mdi-home-silo-outline',
                    name: i18n.t('mensagens.preAnaliseCredito.modulos.patrimonio'),
                    searchSucceeded: true,
                    disabled: false
                },
                {
                    index: '5',
                    icon: 'mdi mdi-account-outline',
                    name: i18n.t('mensagens.preAnaliseCredito.modulos.pessoaPoliticamenteExposta'),
                    searchSucceeded: true,
                    disabled: false
                },
                {
                    index: '6',
                    icon: 'mdi mdi-folder-open-outline',
                    name: i18n.t('mensagens.preAnaliseCredito.modulos.processosJudiciais'),
                    searchSucceeded: true,
                    disabled: false
                },
                {
                    index: '7',
                    icon: 'mdi mdi-account-group-outline',
                    name: i18n.t('mensagens.preAnaliseCredito.modulos.relacionamentos'),
                    searchSucceeded: true,
                    disabled: false
                },
                {
                    index: '8',
                    icon: 'mdi mdi-file-document-outline',
                    name: i18n.t('mensagens.preAnaliseCredito.modulos.sancoesRestricoes'),
                    searchSucceeded: true,
                    disabled: false
                }
            ];

            if (dados.pessoaPgfnDau) {
                if (dados.pessoaPgfnDau.dividas) {
                    itemsMenu[1].searchSucceeded = false;
                }
            }

            if (
                dados.cnep ||
                dados.cnjCnia ||
                dados.empresaBcbAcordaos ||
                dados.empresaCeis ||
                dados.bancoCentral ||
                dados.mandadoPrisao ||
                dados.mteTrabalhoEscravo ||
                dados.punicao ||
                dados.historicoCriminal
            ) {
                itemsMenu[8].searchSucceeded = false;
            }

            if (!this.isProcessoJudicialTotalizadoresEmpty(dados.processoJudicialTotalizadores)) {
                itemsMenu[6].searchSucceeded = false;
            }

            if (dados.bndes) {
                if (!dados.bndes.facets.nome) {
                    itemsMenu[3].disabled = true;
                }
            }

            if (
                !dados.faturamentoEstimado &&
                !dados.mteCnd &&
                !dados.empresaPgfnDau &&
                !dados.cvmParticipantes &&
                !dados.historicoFuncional &&
                !dados.participacaoSocietariaUnico &&
                !dados.sintegraRural &&
                !dados.transparencia &&
                !dados.aeronavesOperadores &&
                !dados.aeronavesProprietarios &&
                !dados?.cafir?.areaTotal &&
                !dados.imoveis &&
                !dados.veiculosPesados &&
                !dados.relacionamentos &&
                !dados.cnep &&
                !dados.cnjCnia &&
                !dados.empresaBcbAcordaos &&
                !dados.empresaCeis &&
                !dados.bancoCentral &&
                !dados.mandadoPrisao &&
                !dados.mteTrabalhoEscravo &&
                !dados.processoJudicialTotalizadores &&
                !dados.punicao &&
                !dados.pessoaPoliticamenteExposta &&
                !dados.historicoCriminal
            ) {
                itemsMenu[0].disabled = true;
                itemsMenu[1].disabled = true;
                itemsMenu[2].disabled = true;
                itemsMenu[4].disabled = true;
                itemsMenu[5].disabled = true;
                itemsMenu[6].disabled = true;
                itemsMenu[7].disabled = true;
                itemsMenu[8].disabled = true;
            }
            return itemsMenu;
        },
        mxItemsMenuPJ(dados) {
            let itemsMenu = [
                {
                    index: '0',
                    icon: 'mdi mdi-cash',
                    name: i18n.t('mensagens.preAnaliseCredito.modulos.dadosFinanceiros'),
                    searchSucceeded: true
                },
                {
                    index: '1',
                    icon: 'mdi mdi-gavel',
                    name: i18n.t('mensagens.preAnaliseCredito.modulos.dadosFiscais'),
                    searchSucceeded: true
                },
                {
                    index: '2',
                    icon: 'mdi mdi-cloud-search-outline',
                    name: i18n.t('mensagens.preAnaliseCredito.modulos.informacoesPublicasBndes'),
                    searchSucceeded: true
                },
                {
                    index: '3',
                    icon: 'mdi mdi-home-silo-outline',
                    name: i18n.t('mensagens.preAnaliseCredito.modulos.patrimonio'),
                    searchSucceeded: true
                },
                {
                    index: '4',
                    icon: 'mdi mdi-folder-open-outline',
                    name: i18n.t('mensagens.preAnaliseCredito.modulos.processosJudiciais'),
                    searchSucceeded: true,
                    disabled: false
                },
                {
                    index: '5',
                    icon: 'mdi mdi-account-group-outline',
                    name: i18n.t('mensagens.preAnaliseCredito.modulos.relacionamentos'),
                    searchSucceeded: true
                },
                {
                    index: '6',
                    icon: 'mdi mdi-file-document-outline',
                    name: i18n.t('mensagens.preAnaliseCredito.modulos.sancoesRestricoes'),
                    searchSucceeded: true
                }
            ];

            if (dados.pessoaPgfnDau) {
                if (dados.pessoaPgfnDau.dividas) {
                    itemsMenu[1].searchSucceeded = false;
                }
            }

            if (
                dados.cnep ||
                dados.cnjCnia ||
                dados.empresaBcbAcordaos ||
                dados.empresaCeis ||
                dados.empresaCepim ||
                dados.mteTrabalhoEscravo ||
                dados.proconInformacoes ||
                dados.tcuContasIrregulares ||
                dados.tcuInidonios ||
                !this.isQsaUnificadoEmpty(dados.qsaUnificado || null)
            ) {
                itemsMenu[6].searchSucceeded = false;
            }

            if (!this.isProcessoJudicialTotalizadoresEmpty(dados.processoJudicialTotalizadores)) {
                itemsMenu[4].searchSucceeded = false;
            }

            if (dados.bndes) {
                if (!dados.bndes.facets.nome) {
                    itemsMenu[2].disabled = true;
                }
            }

            if (
                !dados.totalFuncionarios &&
                !dados.aeronavesOperadores &&
                !dados.aeronavesProprietarios &&
                !dados.cafir &&
                !dados.imoveis &&
                !dados.empresaRegistroBr &&
                !dados.veiculosPesados &&
                !dados.empresaInpiPatentes &&
                !dados.empresaInpiProgramas &&
                !dados.inpiMarcas &&
                !dados.empresaDominio &&
                !dados.totalizadorEmpresasVeiculosPesados &&
                !dados.empresasColigadas &&
                !dados.cnep &&
                !dados.cnjCnia &&
                !dados.empresaBcbAcordaos &&
                !dados.empresaCeis &&
                !dados.mteTrabalhoEscravo &&
                !dados.processoJudicialTotalizadores &&
                !dados.proconInformacoes &&
                !dados.tcuContasIrregulares &&
                !dados.tcuInidonios
            ) {
                itemsMenu[0].disabled = true;
                itemsMenu[1].disabled = true;
                itemsMenu[3].disabled = true;
                itemsMenu[4].disabled = true;
                itemsMenu[5].disabled = true;
                itemsMenu[6].disabled = true;
            }
            return itemsMenu;
        },
        mxCheckTiposPatrimonioPFResults(dados) {
            let tiposPatrimonioArray = [
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.patrimonio.aeronavesOperador'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.patrimonio.aeronavesProprietario'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.patrimonio.imoveisRurais'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.patrimonio.imoveis'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.patrimonio.perfilVeiculoPesado'),
                    temResultados: false
                }
            ];

            if (dados.aeronavesOperadores) {
                tiposPatrimonioArray[0].temResultados = true;
            }

            if (dados.aeronavesProprietarios) {
                tiposPatrimonioArray[1].temResultados = true;
            }

            if (dados.cafir) {
                if (dados.cafir && dados.cafir.areaTotal > 0) {
                    tiposPatrimonioArray[2].temResultados = true;
                }
            }

            if (dados.imoveis) {
                if (dados.imoveis.length > 0) {
                    tiposPatrimonioArray[3].temResultados = true;
                }
            }

            if (dados.veiculosPesados) {
                tiposPatrimonioArray[4].temResultados = true;
            }

            return tiposPatrimonioArray;
        },
        mxCheckTiposPatrimonioPJResults(dados) {
            let tiposPatrimonioArray = [
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.patrimonio.aeronavesOperador'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.patrimonio.aeronavesProprietario'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.patrimonio.imoveisRurais'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.patrimonio.imoveis'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.patrimonio.dominiosAssociadosAoCnpj'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.patrimonio.dominios'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.patrimonio.inpiPatente'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.patrimonio.inpiProgramasDeComputador'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.patrimonio.inpiMarcas'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.patrimonio.veiculosPesadosPorIdadeDaFrota'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.patrimonio.veiculosPesados'),
                    temResultados: false
                }
            ];

            if (dados.aeronavesOperadores) {
                tiposPatrimonioArray[0].temResultados = true;
            }

            if (dados.aeronavesProprietarios) {
                tiposPatrimonioArray[1].temResultados = true;
            }

            if (dados.cafir) {
                if (dados.cafir && dados.cafir.areaTotal > 0) {
                    tiposPatrimonioArray[2].temResultados = true;
                }
            }

            if (dados.imoveis) {
                if (dados.imoveis.length > 0) {
                    tiposPatrimonioArray[3].temResultados = true;
                }
            }
            
            if (dados.empresaDominio) {
                if (dados.empresaDominio.dominios) {
                    tiposPatrimonioArray[4].temResultados = true;
                }
            }

            if (dados.empresaRegistroBr) {
                if (dados.empresaRegistroBr.dominios.length > 0) {
                    tiposPatrimonioArray[5].temResultados = true;
                }
            }

            if (dados.empresaInpiPatentes) {
                if (dados.empresaInpiPatentes.pedidos) {
                    tiposPatrimonioArray[6].temResultados = true;
                }
            }

            if (dados.empresaInpiProgramas) {
                if (dados.empresaInpiProgramas.processos) {
                    tiposPatrimonioArray[7].temResultados = true;
                }
            }

            if (dados.inpiMarcas) {
                tiposPatrimonioArray[8].temResultados = true;
            }

            if (dados.totalizadorEmpresasVeiculosPesados) {
                tiposPatrimonioArray[9].temResultados = true;
            }

            if (dados.veiculosPesados) {
                tiposPatrimonioArray[10].temResultados = true;
            }

            return tiposPatrimonioArray;
        },
        mxCheckTiposDadosFinanceirosPFResults(dados) {
            let tiposDadosFinanceirosArray = [
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.dadosFinanceiros.informacoesProfissionais'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.dadosFinanceiros.impostoDeRendaPessoaFisica'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.dadosFinanceiros.modeloRendaVDois'),
                    temResultados: false
                }
            ];

            if (dados['pessoa-renda-estimada-v2']) {
                tiposDadosFinanceirosArray[0].temResultados = true;
                tiposDadosFinanceirosArray[2].temResultados = true;
            }

            if (dados.irpfRestituicao) {
                tiposDadosFinanceirosArray[1].temResultados = true;
            }

            return tiposDadosFinanceirosArray;
        },
        mxCheckTiposDadosFiscaisTributariosPFResults(dados) {},
        mxCheckTiposInfosProfissionaisPFResults(dados) {
            let tiposInfosProfissionaisArray = [
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.dadosFinanceiros.informacoesProfissionais'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.informacoesProfissionais.cvmDadosCadastrais'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.informacoesProfissionais.historicoFuncional'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.informacoesProfissionais.empresasComParticipacaoSocietaria'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.informacoesProfissionais.produtorRural'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.informacoesProfissionais.portalDaTransparencia'),
                    temResultados: false
                }
            ];

            if (dados['pessoa-renda-estimada-v2']) {
                tiposInfosProfissionaisArray[0].temResultados = true;
            }

            if (dados.cvmParticipantes) {
                tiposInfosProfissionaisArray[1].temResultados = true;
            }

            if (dados.historicoFuncional) {
                tiposInfosProfissionaisArray[2].temResultados = true;
            }

            if (dados.participacaoSocietariaUnico) {
                tiposInfosProfissionaisArray[3].temResultados = true;
            }

            if (dados.sintegraRural) {
                if (dados.sintegraRural.ies) {
                    tiposInfosProfissionaisArray[4].temResultados = true;
                }
            }

            if (dados.transparencia) {
                tiposInfosProfissionaisArray[5].temResultados = true;
            }

            return tiposInfosProfissionaisArray;
        },
        mxCheckTiposSancoesRestricoesPFResults(dados) {
            let tiposSancoesRestricoesArray = [
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.sancoesRestricoes.cnepCadastroNacionalDeEmpresasPunidas'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.sancoesRestricoes.cnia'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.sancoesRestricoes.crsfn'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.sancoesRestricoes.ceis'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.sancoesRestricoes.bacen'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.sancoesRestricoes.cnjMandado'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.sancoesRestricoes.mteTrabalhoEscravo'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.sancoesRestricoes.ceafCadastro'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.sancoesRestricoes.certidaoAntecedentesCriminais'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.sancoesRestricoes.tcuListaContasIrregulares'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.sancoesRestricoes.tcuListaLicitantesInidoneos'),
                    temResultados: false
                }
            ];

            if (dados.cnep) {
                if (dados.cnep.processos) {
                    tiposSancoesRestricoesArray[0].temResultados = true;
                }
            }

            if (dados.cnjCnia) {
                if (dados.cnjCnia.processos) {
                    tiposSancoesRestricoesArray[1].temResultados = true;
                }
            }

            if (dados.empresaBcbAcordaos) {
                if (dados.empresaBcbAcordaos.acordaos) {
                    tiposSancoesRestricoesArray[2].temResultados = true;
                }
            }

            if (dados.empresaCeis) {
                if (dados.empresaCeis.sancoes) {
                    tiposSancoesRestricoesArray[3].temResultados = true;
                }
            }

            if (dados.bancoCentral) {
                if (dados.bancoCentral.inabilitados) {
                    tiposSancoesRestricoesArray[4].temResultados = true;
                }
            }

            if (dados.mandadoPrisao) {
                if (dados.mandadoPrisao.mandados) {
                    tiposSancoesRestricoesArray[5].temResultados = true;
                }
            }

            if (dados.mteTrabalhoEscravo) {
                if (dados.mteTrabalhoEscravo.estabelecimentos) {
                    tiposSancoesRestricoesArray[6].temResultados = true;
                }
            }

            if (dados.punicao) {
                if (dados.punicao.punicoes) {
                    tiposSancoesRestricoesArray[7].temResultados = true;
                }
            }

            if (dados.historicoCriminal) {
                tiposSancoesRestricoesArray[8].temResultados = true;
            }

            if (
                dados.tcuContasIrregulares &&
                dados.tcuContasIrregulares.processos
            ) {
                tiposSancoesRestricoesArray[9].temResultados = true;
            }

            if (dados.tcuInidonios && dados.tcuInidonios.processos) {
                tiposSancoesRestricoesArray[10].temResultados = true;
            }

            return tiposSancoesRestricoesArray;
        },
        mxCheckTiposSancoesRestricoesPJResults(dados) {
            let tiposSancoesRestricoesArray = [
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.sancoesRestricoes.cnepCadastroNacionalDeEmpresasPunidas'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.sancoesRestricoes.cnia'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.sancoesRestricoes.crsfn'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.sancoesRestricoes.ceis'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.sancoesRestricoes.cepimEntidadePrivada'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.sancoesRestricoes.mteTrabalhoEscravo'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.sancoesRestricoes.proconAutuacoesGrupoEconomico'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.sancoesRestricoes.proconAutuacoes'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.sancoesRestricoes.tcuListaContasIrregulares'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.sancoesRestricoes.tcuListaLicitantesInidoneos'),
                    temResultados: false
                },
                {
                    titulo: i18n.t('mensagens.preAnaliseCredito.sancoesRestricoes.informacoesSocios'),
                    temResultados: false
                }
            ];

            if (dados.cnep) {
                if (dados.cnep.processos) {
                    tiposSancoesRestricoesArray[0].temResultados = true;
                }
            }

            if (dados.cnjCnia) {
                if (dados.cnjCnia.processos) {
                    tiposSancoesRestricoesArray[1].temResultados = true;
                }
            }

            if (dados.empresaBcbAcordaos) {
                if (dados.empresaBcbAcordaos.acordaos) {
                    tiposSancoesRestricoesArray[2].temResultados = true;
                }
            }

            if (dados.empresaCeis) {
                if (dados.empresaCeis.sancoes) {
                    tiposSancoesRestricoesArray[3].temResultados = true;
                }
            }

            if (dados.empresaCepim) {
                if (dados.empresaCepim.convenios) {
                    tiposSancoesRestricoesArray[4].temResultados = true;
                }
            }

            if (dados.mteTrabalhoEscravo) {
                if (dados.mteTrabalhoEscravo.estabelecimentos) {
                    tiposSancoesRestricoesArray[5].temResultados = true;
                }
            }

            if (dados.proconInformacoes) {
                if (dados.proconInformacoes.grupo.partesGrupo) {
                    tiposSancoesRestricoesArray[6].temResultados = true;
                }
            }

            if (dados.proconInformacoes) {
                if (dados.proconInformacoes.processos) {
                    tiposSancoesRestricoesArray[7].temResultados = true;
                }
            }

            if (
                dados.tcuContasIrregulares &&
                dados.tcuContasIrregulares.processos
            ) {
                tiposSancoesRestricoesArray[8].temResultados = true;
            }

            if (dados.tcuInidonios && dados.tcuInidonios.processos) {
                tiposSancoesRestricoesArray[9].temResultados = true;
            }

            if (
                dados.qsaUnificado &&
                !this.isQsaUnificadoEmpty(dados.qsaUnificado || null)
            ) {
                tiposSancoesRestricoesArray[10].temResultados = true;
            }

            return tiposSancoesRestricoesArray;
        },
        isQsaUnificadoEmpty(input) {
            if (input === null) {
                return true;
            } else {

                for (const item of input) {
                    if (item.categoriaProcessoCriminal !== null) {
                        return false;
                    }
                }
            }

            return true;
        },
        isProcessoJudicialTotalizadoresEmpty(obj) {
            for (const prop in obj) {
                if (typeof obj[prop] === 'object') {
                    if (!this.isProcessoJudicialTotalizadoresEmpty(obj[prop])) {
                        return false;
                    }
                } else if (obj[prop] !== null && obj[prop] !== 0) {
                    return false;
                }
            }
            return true;
        },
        mxFormatarData(data) {
            if (!data) {
                return '- -';
            }
            if (typeof data !== 'object') {
                const partes = data.split('T')[0].split('-');
                const dia = partes[2];
                const mes = partes[1];
                const ano = partes[0];

                return `${ano}-${mes}-${dia}`;
            } else {
                const { dayOfMonth, monthValue, year, hour, minute, second } = data;

                const dia = String(dayOfMonth).padStart(2, '0');
                const mes = String(monthValue).padStart(2, '0');

                return `${year}-${mes}-${dia} ${hour}:${minute}:${second}`;
            }
        },
        mxFormatarDataHistoricoTable(data) {
            if (!data) {
                return '- -';
            }
            if (typeof data !== 'object') {
                const partes = data.split('T')[0].split('-');
                let dia = partes[2];
                let mes = partes[1];
                let ano = partes[0];

                if (dia.indexOf(' ') >= 0) {
                    dia = dia.split(' ')[0];
                }

                return `${dia}/${mes}/${ano}`;
            } else {
                const { dayOfMonth, monthValue, year } = data;

                const dia = String(dayOfMonth).padStart(2, '0');
                const mes = String(monthValue).padStart(2, '0');

                return `${dia}/${mes}/${year}`;
            }
        },
        mxFormatarDataMes(data) {
            if (!data) {
                return '- -';
            }
            if (typeof data !== 'object') {
                const partes = data.split('T')[0].split('-');
                const dia = partes[2];
                const mes = partes[1];

                return `${dia}/${mes}`;
            } else {
                const { dayOfMonth, monthValue } = data;

                const dia = String(dayOfMonth).padStart(2, '0');
                const mes = String(monthValue).padStart(2, '0');

                return `${dia}/${mes}`;
            }
        },
        mxNormalisarNomes(nome) {
            if (!nome) return i18n.t('mensagens.preAnaliseCredito.visualizar.container.nomeNaoEncontrado');

            const prepositions = ['de', 'do', 'da', 'dos', 'das', 'e', 'ou'];
            const palavras = nome.toLowerCase().split(' ');

            const normalizedWords = palavras.map((palavra, index) => {
                if (index === 0 || !prepositions.includes(palavra)) {
                    return palavra.charAt(0).toUpperCase() + palavra.slice(1);
                } else {
                    return palavra;
                }
            });

            return normalizedWords.join(' ');
        },
        mxGetMesAtual() {
            return mesAnoFormatado;
        },
        mxFormatarHora(hora) {
            const { hour, minute, second } = hora;
            return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}:${second.toString().padStart(2, '0')}`;
        }
    }
};
